import React from "react";

const MenuGroupDivider = () => (
  <div className="border-b border-primary my-4 mx-6"></div>
);

export default MenuGroupDivider;
